

class _ProcessEnvMgr {
  get(key: string): string {
    return process.env[key];
  }

  useGGLogin () {
    let useGGLogin : string | number = process.env.REACT_APP_USE_GOOGLE_LOGIN;
    if (!useGGLogin) {
      return false;
    }

    useGGLogin = (useGGLogin + '').trim().toLowerCase();
    if (useGGLogin.startsWith('f')) {
      return false;
    }
    if (useGGLogin.startsWith('t')) {
      return true;
    }
    if (Number.isNaN(useGGLogin)) {
      return false;
    }

    useGGLogin = Number(useGGLogin);
    if (useGGLogin === 0) {
      return false;
    }
    return true;
  }

  get mode () {
    return process.env.REACT_APP_MODE?.trim();
  }

  useFBLogin() {
    return false;
  }

  useAppleLogin() {
    return false;
  }

  useZACCLogin() {
    return false;
  }
}

const processEnvMgr = new _ProcessEnvMgr();
export default processEnvMgr;
